/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import {
  search
} from 'libs/rcmSearchApi'

import './styles.scss'

class ResultsPagination {
  constructor (element) {
    this.$el = $(element)

    this.isStandalone = this.$el[0].hasAttribute('data-is-standalone') && (this.$el.attr('data-is-standalone') === 'true')

    this.$pageNumberList = this.$el.find('.resultsPagination-pageList')
    this.$pageNumberTemplate = this.$el.find('.resultsPagination-pageNumber')
    this.$ellipsisTemplate = this.$el.find('.resultsPagination-ellipsis')

    this.currentPage = (this.isStandalone) ? parseInt(this.$el.attr('data-current-page')) : 1
    this.maxPages = (this.isStandalone) ? parseInt(this.$el.attr('data-total-pages')) : null
    this.isLoading = false

    this.nextPage = this.nextPage.bind(this)
    this.prevPage = this.prevPage.bind(this)
    this.onNumberClick = this.onNumberClick.bind(this)

    this.$pageNumberTemplate.remove()
    this.$pageNumberTemplate.removeClass('u--hide')

    this.$ellipsisTemplate.remove()
    this.$ellipsisTemplate.removeClass('u--hide')

    if (this.isStandalone) {
      this.updatePagination(this.currentPage, this.maxPages)
    } else {
      this.updatePagination(1, 1)
    }

    this.$el.find('.resultsPagination-prev').on('click', this.prevPage)
    this.$el.find('.resultsPagination-next').on('click', this.nextPage)

    this.$el.find('.resultsPagination-pageList').on('click', '.resultsPagination-pageNumberLink', this.onNumberClick)
  }

  setLoading (isLoading) {
    this.isLoading = isLoading
  }

  nextPage (e) {
    if (this.isStandalone) {
      window.location = $(e.currentTarget).attr('data-url')
    } else {
      search.nextPage()
    }
  }

  prevPage (e) {
    if (this.isStandalone) {
      window.location = $(e.currentTarget).attr('data-url')
    } else {
      search.prevPage()
    }
  }

  onNumberClick (e) {
    e.preventDefault()

    const page = parseInt($(e.currentTarget).attr('data-page'))

    if (this.isStandalone) {
      window.location = window.location.pathname + '?page=' + page
    } else {
      search.setPage(page)
    }
  }

  updatePagination (currentPage, maxPages) {
    let hasPrevEllipsis = false
    let hasNextEllipsis = false
    let lowRange = currentPage - 1
    let highRange = currentPage + 1

    if (lowRange < 2) {
      highRange += (2 - lowRange)
    }

    if (highRange >= maxPages) {
      lowRange -= (1 + (highRange - maxPages))
    }

    this.$pageNumberList.html('')
    this.currentPage = currentPage

    if (maxPages > 0) {
      this.$el.removeClass('u--hide')
    } else {
      this.$el.addClass('u--hide')
      return
    }

    let listItems = []
    for (let i = 1; i <= maxPages; i++) {
      if (
        (i === 1) ||
        ((i >= lowRange) && (i <= highRange)) ||
        (i === maxPages)) {
        const $pageNumber = this.$pageNumberTemplate.clone()
        $pageNumber.find('.resultsPagination-pageNumberLink').text(i)
        $pageNumber.find('.resultsPagination-pageNumberLink').attr('data-page', i)
        if (i === currentPage) {
          $pageNumber.addClass('resultsPagination--currentPage')
        }

        listItems.push($pageNumber)
        continue
      }

      if (i > 1) {
        if (!hasPrevEllipsis && (i < (currentPage - 1))) {
          listItems.push(this.$ellipsisTemplate.clone())
          hasPrevEllipsis = true
          continue
        }
      }

      if (i < maxPages) {
        if (!hasNextEllipsis && (i > (currentPage + 1))) {
          listItems.push(this.$ellipsisTemplate.clone())
          hasNextEllipsis = true
          continue
        }
      }
    }

    this.$pageNumberList.append(listItems)

    if (hasPrevEllipsis) {
      this.$pageNumberList.find('li').first().addClass('resultsPagination--distantPage')
    } else if (hasNextEllipsis) {
      this.$pageNumberList.find('li').last().addClass('resultsPagination--distantPage')
    }

    this.$el.find('.resultsPagination-prev').prop('disabled', (currentPage === 1))
    this.$el.find('.resultsPagination-next').prop('disabled', (currentPage === maxPages))

    this.isLoading = false
  }
}

registerClass('ResultsPagination', ResultsPagination)
